<template>
     <div class="jumbotron">
        <div class="container">
            <div class="d-md-flex justify-content-md-between align-items-md-end">
                <div class="banner-content">
                    <h1 class="cs-textstyle-page-title">{{ title }}</h1>
                    <p v-if="subtitle" v-html="subtitle" class="text cs-textstyle-informative-paragraph"></p>
                </div>
                <div v-if="hasSecondarySlot">
                    <slot name="secondary"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-header',

    props: {
        title: {
            type: String,
            default: 'Title',
        },

        subtitle: {
            type: String,
            default: '',
        },
    },

    computed: {
        hasSecondarySlot() {
            return !!this.$slots.secondary
        },
    }

}
</script>

<style lang="scss" scoped>
    .jumbotron {
        // background-image: url('~@/assets/img/head.png');
        background-color: var(--cs-primary-base);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom right;
        border-radius: 0;
        color: #ffffff;
        padding-top: 1rem;
        padding-bottom: 1rem;
        text-align: center;
        @include media-breakpoint-up(md) {
            text-align: left;
            background-position: bottom center;
            padding-top: 3.4rem;
            padding-bottom: 2.8rem;
        }
    }

    h1 {
        position: relative;
        z-index: 1;
        display: inline-block;
        @include media-breakpoint-up(md) {
            display: block;
        }
        // 
        // &:before {
        //     content: '';
        //     border-radius: 50%;
        //     position: absolute;
        //     border: 4px solid #00C472;
        //     z-index: -1;
        //     top: -2px;
        //     left: -25px;
        //     width: 40px;
        //     height: 40px;
        // }
    }

    .text {
        color: white;
        display: none;
        @include media-breakpoint-up(md) {
            display: block;
        }

        /deep/ p {
            margin-bottom: 0;
        }
    }

    .banner-content {
        @include media-breakpoint-up(md) {
            max-width: 500px;
        }
    }
</style>
